var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-container"},[_c('sidebar-head',{attrs:{"sidebar-dashboard":_vm.sidebarDashboard}}),_c('sidebar-list'),_c('sidebar-social-networks'),_c('sidebar-user-agreement')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }